
  import { Component, Prop, Vue }                       from 'vue-property-decorator';
  import   CarouselComponent                            from '../carousel/CarouselComponent.vue';
  import { EventBus,
           ConfigThemeService }                         from '../../';

  @Component({
    name: 'PopupScreenComponent',
    components: {
      CarouselComponent
    }
  })
  export default class PopupScreenComponent extends Vue {
    @Prop() tabClassName?:string;

    open: boolean = false;
    allElements: NodeListOf<HTMLElement> | null  = null;
    elementIndex: number = 0;

    /** ******************************************************************** */
    /**                      Get styles                                      */
    /** ******************************************************************** */
    get popupStyles() {
      return ConfigThemeService.getPopupStyles(this.$vuetify);
    }

    get popupCarouselStyles() {
      return {};
    }

    get popupCloseIcon() {
      return ConfigThemeService.getClosePopupPanelIcon();
    }

    get popupCloseIconColor() {
      return ConfigThemeService.getDrawerCloseIconColor(this.$vuetify);
    }

    get popupIconColor() {
      return ConfigThemeService.getPopupIconsColor(this.$vuetify); 
    }
    
    get popupIconBgColor() {
      return ConfigThemeService.getPopupIconsBgColor(this.$vuetify); 
    }
    
    /** ******************************************************************** */
    /**                      Action management                               */
    /** ******************************************************************** */
    openModalWindow() {
      this.open = true;
    }

    closeModalWindow() {
      this.open = false;
    }

    onresize() {
      this.closeModalWindow();
    }

    /** ******************************************************************** */
    /**                      LIFECYCLE HOOKS FUNCTIONS                       */
    /** ******************************************************************** */
    created() {
    }

    mounted(){
      this.updateColors();

      EventBus.$on('ON_IMAGE_SELECTED', (allElements: NodeListOf<HTMLImageElement | HTMLTableElement>, elementIndex: number) => {
        this.allElements = allElements;
        this.elementIndex = elementIndex;
        this.openModalWindow();
      });

      EventBus.$on('ON_TABLE_SELECTED', (allElements: NodeListOf<HTMLImageElement | HTMLTableElement>, elementIndex: number) => {
        this.allElements = allElements;
        this.elementIndex = elementIndex;
        this.openModalWindow();
      });

      EventBus.$on('CLOSE_POP_UP', () => {
        this.closeModalWindow();
      });
    }

    beforeDestroy() {      
      EventBus.$off('ON_IMAGE_SELECTED');
      EventBus.$off('ON_TABLE_SELECTED');
      EventBus.$off('CLOSE_POP_UP');
    }

    updated() {
      this.updateColors();
    }

    updateColors(){
      // update the arrows color 
      let buttonElems: NodeListOf<HTMLElement> | null = this.$el ? this.$el.querySelectorAll('button') : null;
      if(buttonElems){
        buttonElems.forEach(element => {
          element.style.backgroundColor = this.popupIconBgColor ? this.popupIconBgColor : '#b3b0b0cf';
        });
      }
    }
  }
